import { afspraakInviteService, IAfspraakInvite } from '@/services/afspraakInviteService'
import { notify } from '@kyvg/vue3-notification'
import { ActionTree, GetterTree, MutationTree } from 'vuex'

class AfspraakInviteState {
    receivedInvites: IAfspraakInvite[] = []
    sentInvites: IAfspraakInvite[] = []
}

const getters: GetterTree<AfspraakInviteState, any> = {
    getReceivedAfspraakInvites(store) {
        return () => store.receivedInvites
    },
    getSentAfspraakInvites(store) {
        return () => store.sentInvites
    },
}

const mutations: MutationTree<AfspraakInviteState> = {
    setReceivedAfspraakInvites(state, payload: IAfspraakInvite[]) {
        state.receivedInvites = payload
    },
    setSentAfspraakInvites(state, payload: IAfspraakInvite[]) {
        state.sentInvites = payload
    },
}

const doNotifyError = (message: string) => {
    notify({
        group: 'requests',
        title: 'Foutmelding',
        type: 'error',
        text: message,
    })
}

const actions: ActionTree<AfspraakInviteState, any> = {
    getReceivedAfspraakInvites({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            afspraakInviteService
                .getReceivedAfspraakInvites(rootState.groups.selectedGroup.id)
                .then((response) => {
                    if (response.status == 401) {
                        reject('unauthorized')
                    } else {
                        commit('setReceivedAfspraakInvites', response.data)
                        resolve(response.data)
                    }
                })
                .catch((e: Error) => {
                    doNotifyError(`Er is iets misgegaan. Error: ${e.message}`)
                    reject(e)
                })
        })
    },
    getSentAfspraakInvites({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            afspraakInviteService
                .getSentAfspraakInvites(rootState.groups.selectedGroup.id)
                .then((response) => {
                    if (response.status == 401) {
                        reject('unauthorized')
                    } else {
                        commit('setSentAfspraakInvites', response.data)
                        resolve(response.data)
                    }
                })
                .catch((e: Error) => {
                    doNotifyError(`Er is iets misgegaan. Error: ${e.message}`)
                    reject(e)
                })
        })
    },
    sendAfspraakInvite({ rootState }, { afspraakId, naarStamgroepId, bericht }: { afspraakId: number; naarStamgroepId: number; bericht: string }) {
        return new Promise((resolve, reject) => {
            afspraakInviteService
                .sendAfspraakInvite({
                    stamgroepId: rootState.groups.selectedGroup.id,
                    afspraakId: afspraakId,
                    naarStamgroepId: naarStamgroepId,
                    bericht: bericht,
                })
                .then((response) => {
                    if (response.status == 401) {
                        reject('unauthorized')
                    } else {
                        resolve(response.data)
                    }
                })
                .catch((e: Error) => {
                    doNotifyError(`Er is iets misgegaan. Error: ${e.message}`)
                    reject(e)
                })
        })
    },
    acceptAfspraakInvite({ rootState }, inviteId: number) {
        return new Promise((resolve, reject) => {
            afspraakInviteService
                .acceptAfspraakInvite(rootState.groups.selectedGroup.id, inviteId)
                .then((response) => {
                    if (response.status == 401) {
                        reject('unauthorized')
                    } else {
                        resolve(response.data)
                    }
                })
                .catch((e: Error) => {
                    doNotifyError(`Er is iets misgegaan. Error: ${e.message}`)
                    reject(e)
                })
        })
    },
    rejectAfspraakInvite({ rootState }, inviteId: number) {
        return new Promise((resolve, reject) => {
            afspraakInviteService
                .rejectAfspraakInvite(rootState.groups.selectedGroup.id, inviteId)
                .then((response) => {
                    if (response.status == 401) {
                        reject('unauthorized')
                    } else {
                        resolve(response.data)
                    }
                })
                .catch((e: Error) => {
                    doNotifyError(`Er is iets misgegaan. Error: ${e.message}`)
                    reject(e)
                })
        })
    },
}

export default {
    state: new AfspraakInviteState(),
    getters: getters,
    mutations: mutations,
    actions: actions,
}
